import {
  basketSizeCookieName,
  cftoTerritoryCookieName,
  completeProfileDataCookieName,
  experimentsUserIdCookieName,
  foodCatalogueSelectedStoreCookieName,
  insuranceCookieNameForHome,
  insuranceCookieNameForPet,
  insuranceCookieNameForTravel,
  loyaltyCookieRoiName,
  loyaltyCookieUkName,
  loyaltyTokenCookieName,
  msIdentityCookieName,
  msSessionId,
  msUserCookieName,
  onyxAuthCookieName,
  sapStoreIdCookieName,
  savedItemSizeCookieName,
  serverSideOnlyCookies,
  slotDetailsCookieName,
  sparksDataCookieName,
  subChannelCookieName,
  taggstarVisitorIdCookieName,
  trueFitUserTokenCookieName,
} from '@onyx/constants';

export const groups = {
  C0001: { name: 'essential', isConsentRequired: false },
  C0002: { name: 'analytics', isConsentRequired: true },
  C0003: { name: 'functional', isConsentRequired: true },
  C0004: { name: 'personalisation', isConsentRequired: true },
  C0005: { name: 'marketing', isConsentRequired: true },
} as const;

type Group = typeof groups;
export type GroupCode = keyof Group;
export type GroupName = Group[GroupCode]['name'];

const createCookieMap = <T extends Record<string, GroupCode>>(map: T) => map;
export const cookiesPrefixNameWithGroupMap = createCookieMap({
  [experimentsUserIdCookieName]: 'C0001',
  FORCEORIGIN: 'C0003',
  SEEBROWSE: 'C0003',
  platform: 'C0003',
  [serverSideOnlyCookies.resetPasswordTokenCookieName]: 'C0001',
  [loyaltyTokenCookieName]: 'C0001',
  [msUserCookieName]: 'C0001',
  [completeProfileDataCookieName]: 'C0001',
  [msIdentityCookieName]: 'C0001',
  [sparksDataCookieName]: 'C0004',
  [basketSizeCookieName]: 'C0001',
  [savedItemSizeCookieName]: 'C0001',
  [cftoTerritoryCookieName]: 'C0001',
  [slotDetailsCookieName]: 'C0001',
  [msSessionId]: 'C0001',
  [onyxAuthCookieName]: 'C0001',
  [foodCatalogueSelectedStoreCookieName]: 'C0001',
  [taggstarVisitorIdCookieName]: 'C0005',
  [trueFitUserTokenCookieName]: 'C0004',
  [loyaltyCookieUkName]: 'C0001',
  [loyaltyCookieRoiName]: 'C0001',
  [insuranceCookieNameForPet]: 'C0003',
  [insuranceCookieNameForTravel]: 'C0003',
  [insuranceCookieNameForHome]: 'C0003',
  [sapStoreIdCookieName]: 'C0001',
  [subChannelCookieName]: 'C0001',
});

type CookiesMap = typeof cookiesPrefixNameWithGroupMap;
type AllCookiesNames = keyof CookiesMap;
type Suffix = string | number;
type KeysWhereConsentNotRequired = {
  [Code in GroupCode]: Group[Code] extends { isConsentRequired: false }
    ? Code
    : never;
}[GroupCode];

export type AllowedEssentialCookiePrefixName = {
  [CookieName in AllCookiesNames]: CookiesMap[CookieName] extends KeysWhereConsentNotRequired
    ? `${CookieName}${Suffix}`
    : never;
}[AllCookiesNames];

export type AllowedNonEssentialCookiePrefixName = Exclude<
  `${AllCookiesNames}${Suffix}`,
  AllowedEssentialCookiePrefixName
>;
